import React, { useState } from 'react'
import HRSidebar from './HRSidebar'
import { FiSettings } from 'react-icons/fi';
import HRAnalytics from './Analytics/HRAnalytics';
import LeaveApply from './LeaveManagement/LeaveApply';

const HRManagement = () => {
  const [openHRModules, setOpenHRModules] = useState("hrAnalytics");
  
  return (
    <>
    <aside className="channels-panel border-end">
      <div className="channels-header pt-3 px-2">
        <strong>Work Bridge</strong>
        <FiSettings />
      </div>
      <HRSidebar
        setOpenHRModules={setOpenHRModules}
        openHRModules={openHRModules}
      />
    </aside>
    <div className="chat-wrapper">
        <div className="chat-main">
          {openHRModules === "hrAnalytics" && <HRAnalytics />}
          {openHRModules === "leaveApply" && <LeaveApply />}
        </div>
      </div>
    </>
  )
}

export default HRManagement